<template>
  <el-tabs
    v-model="activeTab"
    :stretch="true"
    data-qa="preview-content-data-tabs"
  >
    <el-tab-pane
      v-for="tab in tabs"
      :key="tab.index"
      :label="tab.label"
      :name="tab.index"
    >
      <div :data-qa="`preview-content-data-tab-${tab.index}`">
        <component
          :is="tab.component"
          :initial-profile="initialProfile"
          @data-change="onDataChange"
          @profile-change="onProfileChange"
          @profile-ready="$emit('profile-ready')"
        />
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import PreviewContentUserProfileTab from '@/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentUserProfileTab.vue'
import PreviewContentCustomDataTab from '@/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentCustomDataTab.vue'
import { $can } from '@/core/utils/VueAcl'

export default {
  name: 'PreviewContentDataTabs',
  props: {
    activeChannel: {
      type: String,
      required: false,
      default: 'email'
    },
    initialProfile: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedTab: '',
      currentProfileId: this.initialProfile ? this.initialProfile.id : null,
      customAttrs: null
    }
  },
  mounted() {
    // If the user-profile tab is absent (no permissions), no child will ever
    // emit profile-ready, so signal it here so the preview can still render.
    const hasProfileTab = this.tabs.some(t => t.index === 'user_profile')
    if (!hasProfileTab) {
      this.$emit('profile-ready')
    }
  },
  computed: {
    isEmailActive() {
      return this.activeChannel === 'email'
    },
    tabs() {
      let tabs = []
      let profileTab = {
        index: 'user_profile',
        label: 'User Profile',
        component: PreviewContentUserProfileTab
      }
      let customDataTab = {
        index: 'custom_data',
        label: 'Custom Data',
        component: PreviewContentCustomDataTab
      }

      if ($can('Profile::Read') && $can('UserPersonalData::Read')) {
        tabs.push(profileTab)
      }

      if (
        this.isEmailActive ||
        this.$hasReleaseFlag('mobile-custom-data-preview')
      ) {
        tabs.push(customDataTab)
      }

      return tabs
    },
    activeTab: {
      get() {
        const validTab = this.tabs.find(tab => tab.index === this.selectedTab)
        if (validTab) {
          return validTab.index
        }
        return this.tabs[0].index
      },
      set(selectedTab) {
        if (selectedTab === this.selectedTab) {
          return
        }

        // Reload preview after switch back to User Profile tab
        if (selectedTab === 'user_profile' && this.currentProfileId) {
          this.$emit('data-change', this.currentProfileId)
        }
        this.selectedTab = selectedTab
      }
    }
  },
  methods: {
    onDataChange($event) {
      if (typeof $event === 'string') {
        this.currentProfileId = $event
      }

      this.$emit('data-change', $event)
    },
    onProfileChange(profile) {
      this.$emit('profile-change', profile)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/preview/content-data-tabs/PreviewContentDataTabs.vue